var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.03 552.73C132.85 553.99 179.39 564.07 185.21 565.33C189.09 566.3 192.97 563.39 193.94 559.52C194.91 555.64 192 551.76 188.12 550.79C179.59 548.85 111.32 533.33 102.79 531.39C97.94 530.42 93.09 534.3 94.06 540.12C96 548.65 111.52 616.92 113.45 625.45C114.42 629.33 117.33 631.27 120.24 631.27C125.09 631.27 128 627.39 127.03 622.55C125.67 616.24 114.81 565.82 113.45 559.52C238.55 667.15 425.7 661.33 544 544C546.91 541.09 546.91 536.24 544 533.33C541.09 530.42 537.21 531.39 534.3 534.3C422.79 645.82 246.3 651.64 127.03 552.73Z",
    id: "dLEbZ8wwA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.58 353.94C619.64 372.36 615.76 391.76 609.94 409.21C608.97 413.09 610.91 416.97 614.79 417.94C618.67 418.91 622.55 416.97 623.52 413.09C629.33 393.7 633.21 374.3 635.15 354.91C636.12 351.03 633.21 347.15 629.33 347.15C625.45 347.15 621.58 350.06 621.58 353.94Z",
    id: "g1RciM6RHT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.39 129.94C560.48 132.85 559.52 136.73 562.42 140.61C574.06 156.12 583.76 171.64 592.48 189.09C594.42 192.97 598.3 193.94 602.18 192C606.06 190.06 607.03 186.18 605.09 182.3C596.36 163.88 585.7 146.42 574.06 130.91C572.12 128 567.27 127.03 563.39 129.94Z",
    id: "c6bEF91o7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.61 461.58C579.88 478.06 569.21 494.55 557.58 509.09C554.67 512 555.64 516.85 558.55 519.76C561.45 522.67 566.3 521.7 569.21 518.79C581.82 503.27 592.48 486.79 601.21 469.33C603.15 464.48 602.18 460.61 598.3 458.67C594.42 456.73 590.55 457.7 588.61 461.58Z",
    id: "aa4YjWee5x"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.36 303.52C628.36 303.52 628.36 303.52 629.33 303.52C633.21 303.52 636.12 299.64 636.12 295.76C634.18 276.36 631.27 256 625.45 237.58C624.48 233.7 620.61 231.76 616.73 232.73C612.85 233.7 610.91 237.58 611.88 241.45C616.73 258.91 620.61 277.33 621.58 296.73C621.58 300.61 625.45 303.52 628.36 303.52Z",
    id: "eSYmORpKI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 87.27C506.18 86.01 459.64 75.93 453.82 74.67C446.06 72.73 441.21 83.39 448 87.27C448.97 89.21 450.91 90.18 452.85 91.15C461.38 93.09 529.65 108.61 538.18 110.55C543.03 111.52 547.88 106.67 546.91 101.82C544.97 93.28 529.45 25.02 527.52 16.48C527.52 14.55 525.58 12.61 523.64 11.64C519.76 4.85 509.09 8.73 510.06 17.45C511.42 23.76 522.28 74.18 523.64 80.48C401.45 -28.12 213.33 -22.3 95.03 95.03C92.12 97.94 92.12 102.79 95.03 105.7C97.94 108.61 102.79 108.61 105.7 105.7C216.24 -5.82 393.7 -11.64 512 87.27Z",
    id: "bfSLVAn1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.67 336.48C6.79 336.48 3.88 340.36 3.88 344.24C5.82 363.64 8.73 384 14.55 402.42C15.52 406.3 19.39 408.24 23.27 407.27C26.18 407.27 29.09 403.39 28.12 399.52C23.27 381.09 19.39 362.67 18.42 343.27C18.42 339.39 14.55 336.48 10.67 336.48Z",
    id: "aKXK7E4vt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.48 226.91C10.67 246.3 6.79 265.7 4.85 285.09C4.85 288.97 7.76 292.85 11.64 292.85C15.52 292.85 19.39 289.94 19.39 286.06C21.33 267.64 25.21 248.24 31.03 230.79C31.03 226.91 29.09 223.03 25.21 222.06C21.33 221.09 17.45 223.03 16.48 226.91Z",
    id: "g78GGFSOi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.79 171.64C36.85 175.52 37.82 179.39 41.7 181.33C45.58 183.27 49.45 182.3 51.39 178.42C60.12 161.94 70.79 145.45 82.42 130.91C85.33 128 84.36 123.15 81.45 120.24C78.55 118.3 73.7 119.27 70.79 122.18C58.18 137.7 47.52 154.18 38.79 171.64Z",
    id: "asP6dpaJE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.82 448.97C33.94 450.91 32.97 454.79 34.91 458.67C43.64 476.12 54.3 493.58 65.94 509.09C68.85 512 72.73 512.97 76.61 510.06C79.52 507.15 80.48 503.27 77.58 499.39C65.94 485.82 56.24 469.33 47.52 451.88C45.58 448 41.7 447.03 37.82 448.97Z",
    id: "a4jhCz52uN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.97 171.64C93.09 171.64 89.21 174.55 89.21 179.39C89.21 180.36 89.21 463.52 89.21 463.52C89.21 467.39 92.12 471.27 96 471.27C136.73 471.27 462.55 471.27 544.97 471.27C548.85 471.27 552.73 467.39 552.73 463.52C552.73 435.1 552.73 207.81 552.73 179.39C552.73 175.52 549.82 171.64 545.94 171.64C456.15 171.64 141.87 171.64 96.97 171.64ZM538.18 448.97L390.79 345.21L539.15 196.85L539.15 448.97L538.18 448.97ZM252.12 345.21L103.76 448.97L103.76 196.85L252.12 345.21ZM528.48 186.18L320.97 393.7L114.42 186.18L528.48 186.18ZM262.79 354.91C294.79 386.91 312.57 404.69 316.12 408.24C319.03 411.15 323.88 411.15 326.79 408.24C330.34 404.69 348.12 386.91 380.12 354.91L522.67 455.76L119.27 455.76L262.79 354.91Z",
    id: "e4nZu50UKy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.82 269.58C261.82 312.24 306.42 334.55 349.09 313.21C350.06 312.24 351.03 311.27 351.03 309.33C351.03 307.39 349.09 305.45 345.21 306.42C291.88 327.76 269.58 294.79 269.58 269.58C269.58 239.52 294.79 214.3 324.85 214.3C350.06 214.3 373.33 230.79 373.33 257.94C373.33 272.48 368.48 288 353.94 288C341.33 288 347.15 269.58 352 240.48C352 235.64 350.06 233.7 347.15 233.7C344.24 233.7 342.3 235.64 341.33 238.55C341.33 238.84 341.33 241.16 341.33 241.45C336.48 236.61 329.7 233.7 321.94 233.7C310.3 233.7 298.67 239.52 291.88 250.18C285.09 260.85 284.12 278.3 293.82 288.97C303.52 299.64 325.82 298.67 337.45 285.09C341.33 303.52 382.06 302.55 382.06 258.91C381.09 226.91 354.91 205.58 324.85 205.58C290.91 205.58 261.82 234.67 261.82 269.58ZM303.52 279.27C296.73 273.45 297.7 260.85 302.55 253.09C307.39 245.33 315.15 242.42 323.88 242.42C330.67 242.42 336.48 244.36 340.36 249.21C340.17 250.12 339.2 254.64 337.45 262.79C321.29 279.6 309.98 285.09 303.52 279.27Z",
    id: "a1PziQbJYU"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dLEbZ8wwA",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dLEbZ8wwA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1RciM6RHT",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1RciM6RHT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6bEF91o7d",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6bEF91o7d",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa4YjWee5x",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa4YjWee5x",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eSYmORpKI",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eSYmORpKI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bfSLVAn1",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bfSLVAn1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKXK7E4vt",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKXK7E4vt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g78GGFSOi",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g78GGFSOi",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asP6dpaJE",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asP6dpaJE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4jhCz52uN",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4jhCz52uN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4nZu50UKy",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4nZu50UKy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1PziQbJYU",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1PziQbJYU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email-2.ff91f4ce418ad662fef1dffa1bfb4ba7.svg";
export { ForwardRef as ReactComponent };